import React from "react";
import "./Modal.css";

// styles
import useStyles from "../login/styles";

const ModalDeleteItem = ({ isOpen, closeModal, ClickYes, title, subtitle }) => {
    var classes = useStyles();
    const handleContainerClick = (e) => e.stopPropagation();

    const onYesButton = async e => {
        e.preventDefault();
        closeModal();
        ClickYes();
    }

    const onNoButton = async e => {
        e.preventDefault();
        closeModal();
    }

    return <article className={`modal ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-container" onClick={handleContainerClick}>
            <p style={{ fontSize: "18px", textAlign: "center" }}>{title}</p>
            <p style={{ fontSize: "14px", textAlign: "center" }}>{subtitle}</p>
            <br /> <br />
            <div className={classes.rowButtons}>
                <button
                    className={classes.buttonYes}
                    onClick={onYesButton}
                >SI</button>

                <button
                    className={classes.buttonNo}
                    onClick={onNoButton}
                >NO</button>
            </div>
        </div>
    </article>
}

export default ModalDeleteItem;